import React, {useContext, useState} from 'react'
import { RootStoreContext } from '../../../_stores/rootStore';
import { StatusBarContext } from './StatusBarContext';
import useTargetingPermissions from '../hooks/useTargetingPermissions'
import styles from './../css/StatusLock.module.css'
import Axios from '../../../components/Axios'
import LockStatusText from './LockStatusText.js'

function StatusLock() {

    const rootStore = useContext(RootStoreContext);
    const { permissions } = rootStore.permissionsStore;
    const { isElevatedViewer } = useTargetingPermissions()

    const [confirmAction, setConfirmAction] = useState(null) // { index, label, colorKey }

    const {
        user,
        terr,
        id,
        approved,
        getTotals,
        exercise,
        statusIndex,
        maxChangesPerTerritory,
        minChangesPerTerritory,
        maxPlannedCallsPerTerritory,
        minPlannedCallsPerTerritory,
        totalChangesInTerritory,
        totalProfilesInTerritory,
        perTargetLimitData,
        perCallLimitData,
        exceedsMaxChangesPerTerritory,
        belowMinChangesPerTerritory,
        exceedsMaxUpgradesPerTerritory,
        exceedsMaxDowngradesPerTerritory,
        totalUpgradesInTerritory,
        totalDowngradesInTerritory,
        maxUpgradesPerTerritory,
        maxDowngradesPerTerritory,
        exceedsMaxPlannedCallsPerTerritory,
        belowMinPlannedCallsPerTerritory,
        hasPerTargetLimitErrors,
        hasPerPlannedCallLimitErrors,
        hasUpgradeDowngradeLimitErrors,
        perUpgradeLimitData,
        perDowngradeLimitData,
    } = useContext(StatusBarContext);

    const submit = (index) => {
        setConfirmAction(null)
        let temp = {
            statusID: index,
            ID: exercise.TARGETING_EXERCISE_ID,
            terr: terr,
            username: user.userName
        }
        Axios('/api/v1/targeting/submit-status', temp, (data) => {
            getTotals()
        })

        switch (index) {
            // case 3:
            //     // 3 -- UNDER REVIEW -- OAS needs to review/make changes and submit
            //     emailRequest(index)
            //     break;
            case 4:
                // 4 -- PENDING APPROVAL -- OBD needs to Approve the Target List
                emailRequest(index)
                break;
            case 5:
                // 5 -- REJECTED -- OBD has sent exercise back to OAS for changes
                emailRequest(index)
                break;
            case 6:
                // 6 -- APPROVED -- Targeting exercise for the territory is finalized
                emailRequest(index)
                break;
            default:
                // do nothing
        }
    }

    const emailRequest = (index) => {

        let temp = {
            statusID: index,
            team: exercise.TEAM
        }

        Axios('/api/v1/targeting/get-status-by-id', temp, (status) => {

            let json = {}
            json.REQUEST_TYPE = "IMP TgtEx Submit";
            json.EXERCISE_ID = id
            json.EXERCISE_TERR = terr
            json.STATUS_ID = index
            json.STATUS_NAME = status.STATUS
            json.STATUS_DESCRIPTION = status.DESCRIPTION
            json.REQUESTOR_ID = user.email
            json.REQUESTOR_NAME = user.userName
            json.REQUESTOR_TEAM = user.team
            json.REQUESTOR_TERR = user.terr

            Axios('/api/v1/global/change-request', json, (data) => {
            })

        })
    }

    const perTargetLimitErrorList = Object.entries(perTargetLimitData).flatMap(([targetType, d]) => {
        const errors = [];
        if (d.exceedsMax) errors.push(`Too many ${targetType} reclassifications: ${d.outflowCount} moved away (cap: ${d.maxChanges}).`);
        if (d.belowMin) errors.push(`Too few ${targetType} targets remaining: ${d.finalTotal} (floor: ${d.minRequired}).`);
        return errors;
    });

    const plannedCallLimitErrorList = Object.entries(perCallLimitData).flatMap(([targetType, d]) => {
        const errors = [];
        if (d.exceedsMaxCalls) errors.push(`Cannot submit more than ${d.maxCalls} planned calls for ${targetType} targets.`);
        if (d.belowMinCalls) errors.push(`Cannot submit less than ${d.minCalls} planned calls for ${targetType} targets.`);
        return errors;
    });

    let enableSubmitButton = (
        permissions.targeting.search.statusLocks.canSubmitFromOpen.includes(user.role) 
        && !exceedsMaxChangesPerTerritory
        && !belowMinChangesPerTerritory
        && !exceedsMaxPlannedCallsPerTerritory
        && !belowMinPlannedCallsPerTerritory
        && !hasPerTargetLimitErrors
        && !hasPerPlannedCallLimitErrors
        && !hasUpgradeDowngradeLimitErrors
    ) || ["ADMIN"].includes(user.role)

    let enableApproveButton = (
        !exceedsMaxChangesPerTerritory
        && !belowMinChangesPerTerritory
        && !exceedsMaxUpgradesPerTerritory
        && !exceedsMaxDowngradesPerTerritory
        && !exceedsMaxPlannedCallsPerTerritory
        && !belowMinPlannedCallsPerTerritory
        && !hasPerTargetLimitErrors
        && !hasPerPlannedCallLimitErrors
        && !hasUpgradeDowngradeLimitErrors
    )

    const upgradeDowngradeErrorList = [
        ...Object.entries(perUpgradeLimitData).flatMap(([t, d]) =>
            d.exceedsMax ? [`Too many ${t} upgrades: ${d.upgradeCount} upgraded from ${t} (cap: ${d.maxUpgrades}).`] : []
        ),
        ...Object.entries(perDowngradeLimitData).flatMap(([t, d]) =>
            d.exceedsMax ? [`Too many ${t} downgrades: ${d.downgradeCount} downgraded from ${t} (cap: ${d.maxDowngrades}).`] : []
        ),
    ];

    const lockStatusTextProps = {
        exercise,
        approved,
        statusIndex,
        enableSubmitButton,
        maxChangesPerTerritory,
        minChangesPerTerritory,
        totalChangesInTerritory,
        totalProfilesInTerritory,
        exceedsMaxChangesPerTerritory,
        belowMinChangesPerTerritory,
        exceedsMaxUpgradesPerTerritory,
        exceedsMaxDowngradesPerTerritory,
        totalUpgradesInTerritory,
        totalDowngradesInTerritory,
        maxUpgradesPerTerritory,
        maxDowngradesPerTerritory,
        maxPlannedCallsPerTerritory,
        minPlannedCallsPerTerritory,
        exceedsMaxPlannedCallsPerTerritory,
        belowMinPlannedCallsPerTerritory,
        hasPerTargetLimitErrors,
        hasPerPlannedCallLimitErrors,
        perTargetLimitErrorList,
        plannedCallLimitErrorList,
        upgradeDowngradeErrorList,
        isElevatedViewer,
    }

    const confirmColorClass = confirmAction?.colorKey === 'reject'
        ? styles.modalConfirmReject
        : confirmAction?.colorKey === 'approve'
            ? styles.modalConfirmApprove
            : styles.modalConfirmSubmit

    const confirmModal = confirmAction && (
        <div className={styles.modalOverlay} onClick={() => setConfirmAction(null)}>
            <div className={styles.modal} onClick={e => e.stopPropagation()}>
                <p className={styles.modalTitle}>Are you sure?</p>
                <p className={styles.modalBody}>This will {confirmAction.label.toLowerCase()} the targeting exercise for this territory.</p>
                <div className={styles.modalActions}>
                    <button className={styles.modalCancel} onClick={() => setConfirmAction(null)}>Cancel</button>
                    <button className={[styles.modalConfirm, confirmColorClass].join(' ')} onClick={() => submit(confirmAction.index)}>{confirmAction.label}</button>
                </div>
            </div>
        </div>
    )

    if (!approved) {
        if (permissions.targeting.search.statusLocks.general.oneTwo.includes(user.role) && (statusIndex === 0 || statusIndex === 1 || statusIndex === 2)) {
            return (
                <div key={"Lock"} className={styles.wrapper}>
                    {confirmModal}
                    <div className={styles.textArea}>
                        <LockStatusText {...lockStatusTextProps} />
                    </div>
                    <button className={enableSubmitButton ? styles.submit : styles.deactive} onClick={() => {
                        if (!enableSubmitButton) return
                        setConfirmAction({
                            index: (
                                permissions.targeting.search.statusLocks.submitToUnderReview.roles.includes(user.role)
                                || permissions.targeting.search.statusLocks.submitToUnderReview.teams.includes(user.team)
                            ) ? 3 : 4,
                            label: 'Submit',
                            colorKey: 'submit',
                        })
                    }}>SUBMIT</button>
                </div>
            )
        }
        else if (permissions.targeting.search.statusLocks.general.threeFive.includes(user.role) && (statusIndex === 3 || statusIndex === 5)) {
            if (statusIndex === 5) {
                return (
                    <div key={"Lock"} className={styles.wrapper}>
                        {confirmModal}
                        <div className={styles.textArea}>
                            <LockStatusText {...lockStatusTextProps} />
                        </div>
                        <button className={enableSubmitButton ? styles.submit : styles.deactive} onClick={() => {
                            if (!enableSubmitButton) return
                            setConfirmAction({
                                index: (
                                    permissions.targeting.search.statusLocks.submitToUnderReview.roles.includes(user.role)
                                    || permissions.targeting.search.statusLocks.submitToUnderReview.teams.includes(user.team)
                                ) ? 3 : 4,
                                label: 'Submit',
                                colorKey: 'submit',
                            })
                        }}>SUBMIT</button>
                    </div>
                )
            }
            else {
                return (
                    <div key={"Lock"} className={styles.wrapper}>
                        {confirmModal}
                        <div className={styles.textArea}>
                            <div className={styles.statusText}>Progress is automatically saved.</div>
                        </div>
                        <button className={styles.submit} onClick={() => {
                            setConfirmAction({ index: 4, label: 'Submit', colorKey: 'submit' })
                        }}>SUBMIT</button>
                    </div>
                )
            }

        }
        else if (permissions.targeting.search.statusLocks.admin.four.includes(user.role) && (statusIndex === 4 /*|| statusIndex === 5*/)) {
            return (
                <div key={"Lock"} className={styles.wrapper}>
                    {confirmModal}
                    <div className={styles.textArea}>
                        <LockStatusText {...lockStatusTextProps} enableSubmitButton={enableApproveButton} />
                    </div>
                    <div className={styles.buttonRow}>
                        <button className={styles.reject} onClick={() => {
                            setConfirmAction({ index: 5, label: 'Reject', colorKey: 'reject' })
                        }}>REJECT</button>
                        <button className={enableApproveButton ? styles.approve : styles.deactive} onClick={() => {
                            if (!enableApproveButton) return
                            setConfirmAction({ index: 6, label: 'Approve', colorKey: 'approve' })
                        }}>APPROVE</button>
                    </div>
                </div>
            )
        }
    }
    return (
        <div key={"Lock"} className={styles.wrapper}>
            <div className={styles.textArea}>
                <LockStatusText {...lockStatusTextProps} locked={true} />
            </div>
            <button disabled className={styles.deactive}>SUBMIT</button>
        </div>
    )
}

export default StatusLock
